import * as React from "react";
import ReactDOM from "react-dom/client";
import { Root } from ".";

// Entrypoint for react
ReactDOM.createRoot(document.getElementById("app-main") as HTMLDivElement).render(<Root />);
